module.exports = __webpack_public_path__ + "static/img_tb-7379c22f9308210a53b59566cb862f49.png";